(() => {
  if (window.__colleaguesCookieBannerLoaded) return;
  window.__colleaguesCookieBannerLoaded = true;

  const banner = document.getElementById('colleagues-cookie-banner');
  const settingsTemplate = document.getElementById('oc-cookie-settings-template');
  if (!banner) return;

  const mainView = banner.querySelector('[data-cookie-view="main"]');
  const preferencesView = banner.querySelector('[data-cookie-view="preferences"]');
  const previewMode = new URLSearchParams(window.location.search).get('oc_cookie_preview') === '1';
  const seenStorageKey = 'colleagues_cookie_banner_seen_v2';
  const seenMaxAge = 180 * 24 * 60 * 60 * 1000;
  let privacyApi = null;
  let hideTimer = 0;

  if (previewMode) banner.classList.add('is-preview');

  const consentInputs = {
    preferences: banner.querySelector('[data-cookie-consent="preferences"]'),
    analytics: banner.querySelector('[data-cookie-consent="analytics"]'),
    marketing: banner.querySelector('[data-cookie-consent="marketing"]'),
  };

  const hasSeenBannerRecently = () => {
    try {
      const raw = window.localStorage.getItem(seenStorageKey);
      if (!raw) return false;
      const seenAt = Number(raw);
      if (!Number.isFinite(seenAt)) return false;
      if (Date.now() - seenAt > seenMaxAge) {
        window.localStorage.removeItem(seenStorageKey);
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const markBannerSeen = () => {
    try {
      window.localStorage.setItem(seenStorageKey, String(Date.now()));
    } catch (error) {}
  };

  const setView = (view) => {
    const showPreferences = view === 'preferences';
    mainView.hidden = showPreferences;
    preferencesView.hidden = !showPreferences;
    banner.querySelector('[data-cookie-action="preferences"]')?.setAttribute('aria-expanded', String(showPreferences));
    window.clearTimeout(hideTimer);
    banner.hidden = false;
    requestAnimationFrame(() => {
      banner.classList.add('is-visible');
      const target = showPreferences
        ? preferencesView.querySelector('input:not(:disabled), button')
        : mainView.querySelector('button');
      target?.focus({ preventScroll: true });
    });
  };

  const closeBanner = () => {
    banner.classList.remove('is-visible', 'is-saving');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => {
      banner.hidden = true;
    }, 230);
  };

  const hydrateInputs = () => {
    if (!privacyApi?.currentVisitorConsent) return;
    const current = privacyApi.currentVisitorConsent();
    Object.entries(consentInputs).forEach(([key, input]) => {
      if (input) input.checked = current?.[key] === 'yes';
    });
  };

  const connectPrivacy = (callback) => {
    if (window.Shopify?.customerPrivacy) {
      privacyApi = window.Shopify.customerPrivacy;
      callback?.(privacyApi);
      return;
    }

    if (!window.Shopify?.loadFeatures) {
      window.setTimeout(() => connectPrivacy(callback), 120);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify?.customerPrivacy) return;
        privacyApi = window.Shopify.customerPrivacy;
        callback?.(privacyApi);
      }
    );
  };

  const submitConsent = (consent) => {
    markBannerSeen();

    if (previewMode) {
      closeBanner();
      return;
    }

    connectPrivacy((api) => {
      banner.classList.add('is-saving');
      api.setTrackingConsent(consent, closeBanner);
    });
  };

  const openPreferences = () => {
    if (previewMode) {
      setView('preferences');
      return;
    }

    connectPrivacy(() => {
      hydrateInputs();
      setView('preferences');
    });
  };

  banner.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cookie-action]');
    if (!button) return;

    const action = button.dataset.cookieAction;
    if (action === 'accept') {
      submitConsent({ preferences: true, analytics: true, marketing: true });
    } else if (action === 'decline') {
      submitConsent({ preferences: false, analytics: false, marketing: false });
    } else if (action === 'preferences') {
      openPreferences();
    } else if (action === 'back') {
      setView('main');
    } else if (action === 'save') {
      submitConsent({
        preferences: Boolean(consentInputs.preferences?.checked),
        analytics: Boolean(consentInputs.analytics?.checked),
        marketing: Boolean(consentInputs.marketing?.checked),
      });
    }
  });

  banner.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeBanner();
  });

  const insertSettingsLink = () => {
    if (!settingsTemplate || document.querySelector('.oc-cookie-settings-link')) return;
    const target = document.querySelector('.ss-site-footer__legal-links') || document.querySelector('footer');
    if (!target) return;
    target.append(settingsTemplate.content.cloneNode(true));
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('.oc-cookie-settings-link, [data-cookie-action="reopen"]');
      if (trigger) {
        event.preventDefault();
        openPreferences();
        return;
      }

      const possibleNativeLink = event.target.closest('a, button');
      if (!possibleNativeLink || banner.contains(possibleNativeLink)) return;
      const label = possibleNativeLink.textContent?.trim().toLowerCase() || '';
      if (
        label === 'cookie preferences' ||
        label === 'cookie settings' ||
        label === 'préférences cookies' ||
        label === 'préférences de cookies'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openPreferences();
      }
    },
    true
  );

  const initialize = () => {
    insertSettingsLink();

    if (previewMode) {
      setView('main');
      return;
    }

    connectPrivacy((api) => {
      if (api.shouldShowBanner?.() && !hasSeenBannerRecently()) {
        markBannerSeen();
        setView('main');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();